export const monthLocales: any = {
  af: [
    { label: "Januarie", value: "01" },
    { label: "Februarie", value: "02" },
    { label: "Maart", value: "03" },
    { label: "April", value: "04" },
    { label: "Mei", value: "05" },
    { label: "Junie", value: "06" },
    { label: "Julie", value: "07" },
    { label: "Augustus", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "November", value: "11" },
    { label: "Desember", value: "12" },
  ],
  "ar-LB": [
    { label: "جانفي", value: "01" },
    { label: "فيفري", value: "02" },
    { label: "مارس", value: "03" },
    { label: "أفريل", value: "04" },
    { label: "ماي", value: "05" },
    { label: "جوان", value: "06" },
    { label: "جويلية", value: "07" },
    { label: "أوت", value: "08" },
    { label: "سبتمبر", value: "09" },
    { label: "أكتوبر", value: "10" },
    { label: "نوفمبر", value: "11" },
    { label: "ديسمبر", value: "12" },
  ],
  "at-TN": [
    { label: "جانفي", value: "01" },
    { label: "فيفري", value: "02" },
    { label: "مارس", value: "03" },
    { label: "أفريل", value: "04" },
    { label: "ماي", value: "05" },
    { label: "جوان", value: "06" },
    { label: "جويلية", value: "07" },
    { label: "أوت", value: "08" },
    { label: "سبتمبر", value: "09" },
    { label: "أكتوبر", value: "10" },
    { label: "نوفمبر", value: "11" },
    { label: "ديسمبر", value: "12" },
  ],
  "ar-MA": [
    { label: "كانون الثاني", value: "01" },
    { label: "شباط", value: "02" },
    { label: "آذار", value: "03" },
    { label: "نيسان", value: "04" },
    { label: "مايو", value: "05" },
    { label: "حزيران", value: "06" },
    { label: "تموز", value: "07" },
    { label: "آب", value: "08" },
    { label: "أيلول", value: "09" },
    { label: "تشرين الأول", value: "10" },
    { label: "تشرين الثاني", value: "11" },
    { label: "كانون الأول", value: "12" },
  ],
  az: [
    { label: "Yanvar", value: "01" },
    { label: "Fevral", value: "02" },
    { label: "Mart", value: "03" },
    { label: "Aprel", value: "04" },
    { label: "May", value: "05" },
    { label: "İyun", value: "06" },
    { label: "İyul", value: "07" },
    { label: "Avqust", value: "08" },
    { label: "Sentyabr", value: "09" },
    { label: "Oktyabr", value: "10" },
    { label: "Noyabr", value: "11" },
    { label: "Dekabr", value: "12" },
  ],
  "bg-BG": [
    { label: "Януари", value: "01" },
    { label: "Февруари", value: "02" },
    { label: "Март", value: "03" },
    { label: "Април", value: "04" },
    { label: "Май", value: "05" },
    { label: "Юни", value: "06" },
    { label: "Юли", value: "07" },
    { label: "Август", value: "08" },
    { label: "Септември", value: "09" },
    { label: "Октомври", value: "10" },
    { label: "Ноември", value: "11" },
    { label: "Декември", value: "12" },
  ],
  bs: [
    { label: "Januar", value: "01" },
    { label: "Februar", value: "02" },
    { label: "Mart", value: "03" },
    { label: "April", value: "04" },
    { label: "Maj", value: "05" },
    { label: "Juni", value: "06" },
    { label: "Juli", value: "07" },
    { label: "August", value: "08" },
    { label: "Septembar", value: "09" },
    { label: "Oktobar", value: "10" },
    { label: "Novembar", value: "11" },
    { label: "Decembar", value: "12" },
  ],
  ca: [
    { label: "Gener", value: "01" },
    { label: "Febrer", value: "02" },
    { label: "Març", value: "03" },
    { label: "Abril", value: "04" },
    { label: "Maig", value: "05" },
    { label: "Juny", value: "06" },
    { label: "Juliol", value: "07" },
    { label: "Agost", value: "08" },
    { label: "Setembre", value: "09" },
    { label: "Octubre", value: "10" },
    { label: "Novembre", value: "11" },
    { label: "Desembre", value: "12" },
  ],
  cs: [
    { label: "leden", value: "01" },
    { label: "únor", value: "02" },
    { label: "březen", value: "03" },
    { label: "duben", value: "04" },
    { label: "květen", value: "05" },
    { label: "červen", value: "06" },
    { label: "červenec", value: "07" },
    { label: "srpen", value: "08" },
    { label: "září", value: "09" },
    { label: "říjen", value: "10" },
    { label: "listopad", value: "11" },
    { label: "prosinec", value: "12" },
  ],
  "cy-GB": [
    { label: "Ionawr", value: "01" },
    { label: "Chwefror", value: "02" },
    { label: "Mawrth", value: "03" },
    { label: "Ebrill", value: "04" },
    { label: "Mai", value: "05" },
    { label: "Mehefin", value: "06" },
    { label: "Gorffennaf", value: "07" },
    { label: "Awst", value: "08" },
    { label: "Medi", value: "09" },
    { label: "Hydref", value: "10" },
    { label: "Tachwedd", value: "11" },
    { label: "Rhagfyr", value: "12" },
  ],
  da: [
    { label: "Januar", value: "01" },
    { label: "Februar", value: "02" },
    { label: "Marts", value: "03" },
    { label: "April", value: "04" },
    { label: "Maj", value: "05" },
    { label: "Juni", value: "06" },
    { label: "Juli", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],
  de: [
    { label: "Januar", value: "01" },
    { label: "Februar", value: "02" },
    { label: "März", value: "03" },
    { label: "April", value: "04" },
    { label: "Mai", value: "05" },
    { label: "Juni", value: "06" },
    { label: "Juli", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "November", value: "11" },
    { label: "Dezember", value: "12" },
  ],
  el: [
    { label: "Ιανουάριος", value: "01" },
    { label: "Φεβρουάριος", value: "02" },
    { label: "Μάρτιος", value: "03" },
    { label: "Απρίλιος", value: "04" },
    { label: "Μάιος", value: "05" },
    { label: "Ιούνιος", value: "06" },
    { label: "Ιούλιος", value: "07" },
    { label: "Αύγουστος", value: "08" },
    { label: "Σεπτέμβριος", value: "09" },
    { label: "Οκτώβριος", value: "10" },
    { label: "Νοέμβριος", value: "11" },
    { label: "Δεκέμβριος", value: "12" },
  ],
  "en-AU": [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],
  "en-GB": [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],
  "en-NZ": [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],
  eo: [
    { label: "Januaro", value: "01" },
    { label: "Februaro", value: "02" },
    { label: "Marto", value: "03" },
    { label: "Aprilo", value: "04" },
    { label: "Majo", value: "05" },
    { label: "Junio", value: "06" },
    { label: "Julio", value: "07" },
    { label: "Aŭgusto", value: "08" },
    { label: "Septembro", value: "09" },
    { label: "Oktobro", value: "10" },
    { label: "Novembro", value: "11" },
    { label: "Decembro", value: "12" },
  ],
  es: [
    { label: "Enero", value: "01" },
    { label: "Febrero", value: "02" },
    { label: "Marzo", value: "03" },
    { label: "Abril", value: "04" },
    { label: "Mayo", value: "05" },
    { label: "Junio", value: "06" },
    { label: "Julio", value: "07" },
    { label: "Agosto", value: "08" },
    { label: "Septiembre", value: "09" },
    { label: "Octubre", value: "10" },
    { label: "Noviembre", value: "11" },
    { label: "Diciembre", value: "12" },
  ],
  et: [
    { label: "Jaanuar", value: "01" },
    { label: "Veebruar", value: "02" },
    { label: "Märts", value: "03" },
    { label: "Aprill", value: "04" },
    { label: "Mai", value: "05" },
    { label: "Juuni", value: "06" },
    { label: "Juuli", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktoober", value: "10" },
    { label: "November", value: "11" },
    { label: "Detsember", value: "12" },
  ],
  eu: [
    { label: "urtarrila", value: "01" },
    { label: "otsaila", value: "02" },
    { label: "martxoa", value: "03" },
    { label: "apirila", value: "04" },
    { label: "maiatza", value: "05" },
    { label: "ekaina", value: "06" },
    { label: "uztaila", value: "07" },
    { label: "abuztua", value: "08" },
    { label: "iraila", value: "09" },
    { label: "urria", value: "10" },
    { label: "azaroa", value: "11" },
    { label: "abendua", value: "12" },
  ],
  fa: [
    { label: "فروردين", value: "01" },
    { label: "ارديبهشت", value: "02" },
    { label: "خرداد", value: "03" },
    { label: "تير", value: "04" },
    { label: "مرداد", value: "05" },
    { label: "شهريور", value: "06" },
    { label: "مهر", value: "07" },
    { label: "آبان", value: "08" },
    { label: "آذر", value: "09" },
    { label: "دی", value: "10" },
    { label: "بهمن", value: "11" },
    { label: "اسفند", value: "12" },
  ],
  fi: [
    { label: "Tammikuu", value: "01" },
    { label: "Helmikuu", value: "02" },
    { label: "Maaliskuu", value: "03" },
    { label: "Huhtikuu", value: "04" },
    { label: "Toukokuu", value: "05" },
    { label: "Kesäkuu", value: "06" },
    { label: "Heinäkuu", value: "07" },
    { label: "Elokuu", value: "08" },
    { label: "Syyskuu", value: "09" },
    { label: "Lokakuu", value: "10" },
    { label: "Marraskuu", value: "11" },
    { label: "Joulukuu", value: "12" },
  ],
  fo: [
    { label: "Januar", value: "01" },
    { label: "Februar", value: "02" },
    { label: "Mars", value: "03" },
    { label: "Apríl", value: "04" },
    { label: "Mei", value: "05" },
    { label: "Juni", value: "06" },
    { label: "Juli", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "November", value: "11" },
    { label: "Desember", value: "12" },
  ],
  "fr-MA": [
    { label: "Janvier", value: "01" },
    { label: "Février", value: "02" },
    { label: "Mars", value: "03" },
    { label: "Avril", value: "04" },
    { label: "Mai", value: "05" },
    { label: "Juin", value: "06" },
    { label: "Juillet", value: "07" },
    { label: "Août", value: "08" },
    { label: "Septembre", value: "09" },
    { label: "Octobre", value: "10" },
    { label: "Novembre", value: "11" },
    { label: "Décembre", value: "12" },
  ],
  'fr-TN': [
    { label: "Janvier", value: "01" },
    { label: "Février", value: "02" },
    { label: "Mars", value: "03" },
    { label: "Avril", value: "04" },
    { label: "Mai", value: "05" },
    { label: "Juin", value: "06" },
    { label: "Juillet", value: "07" },
    { label: "Août", value: "08" },
    { label: "Septembre", value: "09" },
    { label: "Octobre", value: "10" },
    { label: "Novembre", value: "11" },
    { label: "Décembre", value: "12" },
  ],
  "sr-SR": [
    { label: "Januar", value: "01" },
    { label: "Februar", value: "02" },
    { label: "Mart", value: "03" },
    { label: "April", value: "04" },
    { label: "Maj", value: "05" },
    { label: "Jun", value: "06" },
    { label: "Jul", value: "07" },
    { label: "Avgust", value: "08" },
    { label: "Septembar", value: "09" },
    { label: "Oktobar", value: "10" },
    { label: "Novembar", value: "11" },
    { label: "Decembar", value: "12" },
  ],
  "sr-RS": [
    { label: "Januar", value: "01" },
    { label: "Februar", value: "02" },
    { label: "Mart", value: "03" },
    { label: "April", value: "04" },
    { label: "Maj", value: "05" },
    { label: "Jun", value: "06" },
    { label: "Jul", value: "07" },
    { label: "Avgust", value: "08" },
    { label: "Septembar", value: "09" },
    { label: "Oktobar", value: "10" },
    { label: "Novembar", value: "11" },
    { label: "Decembar", value: "12" },
  ],
  "sr-ME": [
    { label: "Јануар", value: "01" },
    { label: "Фебруар", value: "02" },
    { label: "Март", value: "03" },
    { label: "Април", value: "04" },
    { label: "Мај", value: "05" },
    { label: "Јун", value: "06" },
    { label: "Јул", value: "07" },
    { label: "Август", value: "08" },
    { label: "Септембар", value: "09" },
    { label: "Октобар", value: "10" },
    { label: "Новембар", value: "11" },
    { label: "Децембар", value: "12" },
  ],
  sv: [
    { label: "Januari", value: "01" },
    { label: "Februari", value: "02" },
    { label: "Mars", value: "03" },
    { label: "April", value: "04" },
    { label: "Maj", value: "05" },
    { label: "Juni", value: "06" },
    { label: "Juli", value: "07" },
    { label: "Augusti", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],
  ta: [
    { label: "தை", value: "01" },
    { label: "மாசி", value: "02" },
    { label: "பங்குனி", value: "03" },
    { label: "சித்திரை", value: "04" },
    { label: "வைகாசி", value: "05" },
    { label: "ஆனி", value: "06" },
    { label: "ஆடி", value: "07" },
    { label: "ஆவணி", value: "08" },
    { label: "புரட்டாசி", value: "09" },
    { label: "ஐப்பசி", value: "10" },
    { label: "கார்த்திகை", value: "11" },
    { label: "மார்கழி", value: "12" },
  ],
  th: [
    { label: "มกราคม", value: "01" },
    { label: "กุมภาพันธ์", value: "02" },
    { label: "มีนาคม", value: "03" },
    { label: "เมษายน", value: "04" },
    { label: "พฤษภาคม", value: "05" },
    { label: "มิถุนายน", value: "06" },
    { label: "กรกฎาคม", value: "07" },
    { label: "สิงหาคม", value: "08" },
    { label: "กันยายน", value: "09" },
    { label: "ตุลาคม", value: "10" },
    { label: "พฤศจิกายน", value: "11" },
    { label: "ธันวาคม", value: "12" },
  ],
  tj: [
    { label: "Январ", value: "01" },
    { label: "Феврал", value: "02" },
    { label: "Март", value: "03" },
    { label: "Апрел", value: "04" },
    { label: "Май", value: "05" },
    { label: "Июн", value: "06" },
    { label: "Июл", value: "07" },
    { label: "Август", value: "08" },
    { label: "Сентябр", value: "09" },
    { label: "Октябр", value: "10" },
    { label: "Ноябр", value: "11" },
    { label: "Декабр", value: "12" },
  ],
  tr: [
    { label: "Ocak", value: "01" },
    { label: "Şubat", value: "02" },
    { label: "Mart", value: "03" },
    { label: "Nisan", value: "04" },
    { label: "Mayıs", value: "05" },
    { label: "Haziran", value: "06" },
    { label: "Temmuz", value: "07" },
    { label: "Ağustos", value: "08" },
    { label: "Eylül", value: "09" },
    { label: "Ekim", value: "10" },
    { label: "Kasım", value: "11" },
    { label: "Aralık", value: "12" },
  ],
  uk: [
    { label: "Січень", value: "01" },
    { label: "Лютий", value: "02" },
    { label: "Березень", value: "03" },
    { label: "Квітень", value: "04" },
    { label: "Травень", value: "05" },
    { label: "Червень", value: "06" },
    { label: "Липень", value: "07" },
    { label: "Серпень", value: "08" },
    { label: "Вересень", value: "09" },
    { label: "Жовтень", value: "10" },
    { label: "Листопад", value: "11" },
    { label: "Грудень", value: "12" },
  ],
  vi: [
    { label: "Tháng Một", value: "01" },
    { label: "Tháng Hai", value: "02" },
    { label: "Tháng Ba", value: "03" },
    { label: "Tháng Tư", value: "04" },
    { label: "Tháng Năm", value: "05" },
    { label: "Tháng Sáu", value: "06" },
    { label: "Tháng Bảy", value: "07" },
    { label: "Tháng Tám", value: "08" },
    { label: "Tháng Chín", value: "09" },
    { label: "Tháng Mười", value: "10" },
    { label: "Tháng Mười Một", value: "11" },
    { label: "Tháng Mười Hai", value: "12" },
  ],
  "zh-CN": [
    { label: "一月", value: "01" },
    { label: "二月", value: "02" },
    { label: "三月", value: "03" },
    { label: "四月", value: "04" },
    { label: "五月", value: "05" },
    { label: "六月", value: "06" },
    { label: "七月", value: "07" },
    { label: "八月", value: "08" },
    { label: "九月", value: "09" },
    { label: "十月", value: "10" },
    { label: "十一月", value: "11" },
    { label: "十二月", value: "12" },
  ],
  "zh-HK": [
    { label: "一月", value: "01" },
    { label: "二月", value: "02" },
    { label: "三月", value: "03" },
    { label: "四月", value: "04" },
    { label: "五月", value: "05" },
    { label: "六月", value: "06" },
    { label: "七月", value: "07" },
    { label: "八月", value: "08" },
    { label: "九月", value: "09" },
    { label: "十月", value: "10" },
    { label: "十一月", value: "11" },
    { label: "十二月", value: "12" },
  ],
  "zh-TW": [
    { label: "一月", value: "01" },
    { label: "二月", value: "02" },
    { label: "三月", value: "03" },
    { label: "四月", value: "04" },
    { label: "五月", value: "05" },
    { label: "六月", value: "06" },
    { label: "七月", value: "07" },
    { label: "八月", value: "08" },
    { label: "九月", value: "09" },
    { label: "十月", value: "10" },
    { label: "十一月", value: "11" },
    { label: "十二月", value: "12" },
  ],
  ml: [
    { label: "ജനുവരി", value: "01" },
    { label: "ഫെബ്രുവരി", value: "02" },
    { label: "മാര്‍ച്ച്", value: "03" },
    { label: "ഏപ്രില്‍", value: "04" },
    { label: "മേയ്", value: "05" },
    { label: "ജൂണ്‍", value: "06" },
    { label: "ജൂലൈ", value: "07" },
    { label: "ആഗസ്റ്റ്", value: "08" },
    { label: "സെപ്റ്റംബര്‍", value: "09" },
    { label: "ഒക്ടോബര്‍", value: "10" },
    { label: "നവംബര്‍", value: "11" },
    { label: "ഡിസംബര്‍", value: "12" },
  ],
  ms: [
    { label: "Januari", value: "01" },
    { label: "Februari", value: "02" },
    { label: "Mac", value: "03" },
    { label: "April", value: "04" },
    { label: "Mei", value: "05" },
    { label: "Jun", value: "06" },
    { label: "Julai", value: "07" },
    { label: "Ogos", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "November", value: "11" },
    { label: "Disember", value: "12" },
  ],
  "nl-BE": [
    { label: "januari", value: "01" },
    { label: "februari", value: "02" },
    { label: "maart", value: "03" },
    { label: "april", value: "04" },
    { label: "mei", value: "05" },
    { label: "juni", value: "06" },
    { label: "juli", value: "07" },
    { label: "augustus", value: "08" },
    { label: "september", value: "09" },
    { label: "oktober", value: "10" },
    { label: "november", value: "11" },
    { label: "december", value: "12" },
  ],
  nl: [
    { label: "januari", value: "01" },
    { label: "februari", value: "02" },
    { label: "maart", value: "03" },
    { label: "april", value: "04" },
    { label: "mei", value: "05" },
    { label: "juni", value: "06" },
    { label: "juli", value: "07" },
    { label: "augustus", value: "08" },
    { label: "september", value: "09" },
    { label: "oktober", value: "10" },
    { label: "november", value: "11" },
    { label: "december", value: "12" },
  ],
  no: [
    { label: "januar", value: "01" },
    { label: "februar", value: "02" },
    { label: "mars", value: "03" },
    { label: "april", value: "04" },
    { label: "mai", value: "05" },
    { label: "juni", value: "06" },
    { label: "juli", value: "07" },
    { label: "august", value: "08" },
    { label: "september", value: "09" },
    { label: "oktober", value: "10" },
    { label: "november", value: "11" },
    { label: "desember", value: "12" },
  ],
  'pl-PL': [
    { label: "Styczeń", value: "01" },
    { label: "Luty", value: "02" },
    { label: "Marzec", value: "03" },
    { label: "Kwiecień", value: "04" },
    { label: "Maj", value: "05" },
    { label: "Czerwiec", value: "06" },
    { label: "Lipiec", value: "07" },
    { label: "Sierpień", value: "08" },
    { label: "Wrzesień", value: "09" },
    { label: "Październik", value: "10" },
    { label: "Listopad", value: "11" },
    { label: "Grudzień", value: "12" },
  ],
  "pt-BR": [
    { label: "Janeiro", value: "01" },
    { label: "Fevereiro", value: "02" },
    { label: "Março", value: "03" },
    { label: "Abril", value: "04" },
    { label: "Maio", value: "05" },
    { label: "Junho", value: "06" },
    { label: "Julho", value: "07" },
    { label: "Agosto", value: "08" },
    { label: "Setembro", value: "09" },
    { label: "Outubro", value: "10" },
    { label: "Novembro", value: "11" },
    { label: "Dezembro", value: "12" },
  ],
  pt: [
    { label: "Janeiro", value: "01" },
    { label: "Fevereiro", value: "02" },
    { label: "Março", value: "03" },
    { label: "Abril", value: "04" },
    { label: "Maio", value: "05" },
    { label: "Junho", value: "06" },
    { label: "Julho", value: "07" },
    { label: "Agosto", value: "08" },
    { label: "Setembro", value: "09" },
    { label: "Outubro", value: "10" },
    { label: "Novembro", value: "11" },
    { label: "Dezembro", value: "12" },
  ],
  rm: [
    { label: "Schaner", value: "01" },
    { label: "Favrer", value: "02" },
    { label: "Mars", value: "03" },
    { label: "Avrigl", value: "04" },
    { label: "Matg", value: "05" },
    { label: "Zercladur", value: "06" },
    { label: "Fanadur", value: "07" },
    { label: "Avust", value: "08" },
    { label: "Settember", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],
  'ro-RO': [
    { label: "Ianuarie", value: "01" },
    { label: "Februarie", value: "02" },
    { label: "Martie", value: "03" },
    { label: "Aprilie", value: "04" },
    { label: "Mai", value: "05" },
    { label: "Iunie", value: "06" },
    { label: "Iulie", value: "07" },
    { label: "August", value: "08" },
    { label: "Septembrie", value: "09" },
    { label: "Octombrie", value: "10" },
    { label: "Noiembrie", value: "11" },
    { label: "Decembrie", value: "12" },
  ],
  ru: [
    { label: "Янв", value: "01" },
    { label: "Фев", value: "02" },
    { label: "Мар", value: "03" },
    { label: "Апр", value: "04" },
    { label: "Май", value: "05" },
    { label: "Июн", value: "06" },
    { label: "Июл", value: "07" },
    { label: "Авг", value: "08" },
    { label: "Сен", value: "09" },
    { label: "Окт", value: "10" },
    { label: "Ноя", value: "11" },
    { label: "Дек", value: "12" },
  ],
  sk: [
    { label: "Jan", value: "01" },
    { label: "Feb", value: "02" },
    { label: "Mar", value: "03" },
    { label: "Apr", value: "04" },
    { label: "Máj", value: "05" },
    { label: "Jún", value: "06" },
    { label: "Júl", value: "07" },
    { label: "Aug", value: "08" },
    { label: "Sep", value: "09" },
    { label: "Okt", value: "10" },
    { label: "Nov", value: "11" },
    { label: "Dec", value: "12" },
  ],
  sl: [
    { label: "Jan", value: "01" },
    { label: "Feb", value: "02" },
    { label: "Mar", value: "03" },
    { label: "Apr", value: "04" },
    { label: "Maj", value: "05" },
    { label: "Jun", value: "06" },
    { label: "Jul", value: "07" },
    { label: "Avg", value: "08" },
    { label: "Sep", value: "09" },
    { label: "Okt", value: "10" },
    { label: "Nov", value: "11" },
    { label: "Dec", value: "12" },
  ],
  sq: [
    { label: "Jan", value: "01" },
    { label: "Shk", value: "02" },
    { label: "Mar", value: "03" },
    { label: "Pri", value: "04" },
    { label: "Maj", value: "05" },
    { label: "Qer", value: "06" },
    { label: "Kor", value: "07" },
    { label: "Gus", value: "08" },
    { label: "Sht", value: "09" },
    { label: "Tet", value: "10" },
    { label: "Nën", value: "11" },
    { label: "Dhj", value: "12" },
  ],
  id: [
    { label: "Januari", value: "01" },
    { label: "Februari", value: "02" },
    { label: "Maret", value: "03" },
    { label: "April", value: "04" },
    { label: "Mei", value: "05" },
    { label: "Juni", value: "06" },
    { label: "Juli", value: "07" },
    { label: "Agustus", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "Nopember", value: "11" },
    { label: "Desember", value: "12" },
  ],
  is: [
    { label: "Janúar", value: "01" },
    { label: "Febrúar", value: "02" },
    { label: "Mars", value: "03" },
    { label: "Apríl", value: "04" },
    { label: "Maí", value: "05" },
    { label: "Júní", value: "06" },
    { label: "Júlí", value: "07" },
    { label: "Ágúst", value: "08" },
    { label: "September", value: "09" },
    { label: "Október", value: "10" },
    { label: "Nóvember", value: "11" },
    { label: "Desember", value: "12" },
  ],
  it: [
    { label: "Gennaio", value: "01" },
    { label: "Febbraio", value: "02" },
    { label: "Marzo", value: "03" },
    { label: "Aprile", value: "04" },
    { label: "Maggio", value: "05" },
    { label: "Giugno", value: "06" },
    { label: "Luglio", value: "07" },
    { label: "Agosto", value: "08" },
    { label: "Settembre", value: "09" },
    { label: "Ottobre", value: "10" },
    { label: "Novembre", value: "11" },
    { label: "Dicembre", value: "12" },
  ],
  ja: [
    { label: "1月", value: "01" },
    { label: "2月", value: "02" },
    { label: "3月", value: "03" },
    { label: "4月", value: "04" },
    { label: "5月", value: "05" },
    { label: "6月", value: "06" },
    { label: "7月", value: "07" },
    { label: "8月", value: "08" },
    { label: "9月", value: "09" },
    { label: "10月", value: "10" },
    { label: "11月", value: "11" },
    { label: "12月", value: "12" },
  ],
  ka: [
    { label: "იანვარი", value: "01" },
    { label: "თებერვალი", value: "02" },
    { label: "მარტი", value: "03" },
    { label: "აპრილი", value: "04" },
    { label: "მაისი", value: "05" },
    { label: "ივნისი", value: "06" },
    { label: "ივლისი", value: "07" },
    { label: "აგვისტო", value: "08" },
    { label: "სექტემბერი", value: "09" },
    { label: "ოქტომბერი", value: "10" },
    { label: "ნოემბერი", value: "11" },
    { label: "დეკემბერი", value: "12" },
  ],
  kk: [
    { label: "Қаңтар", value: "01" },
    { label: "Ақпан", value: "02" },
    { label: "Наурыз", value: "03" },
    { label: "Сәуір", value: "04" },
    { label: "Мамыр", value: "05" },
    { label: "Маусым", value: "06" },
    { label: "Шілде", value: "07" },
    { label: "Тамыз", value: "08" },
    { label: "Қыркүйек", value: "09" },
    { label: "Қазан", value: "10" },
    { label: "Қараша", value: "11" },
    { label: "Желтоқсан", value: "12" },
  ],
  km: [
    { label: "មករា", value: "01" },
    { label: "កុម្ភៈ", value: "02" },
    { label: "មីនា", value: "03" },
    { label: "មេសា", value: "04" },
    { label: "ឧសភា", value: "05" },
    { label: "មិថុនា", value: "06" },
    { label: "កក្កដា", value: "07" },
    { label: "សីហា", value: "08" },
    { label: "កញ្ញា", value: "09" },
    { label: "តុលា", value: "10" },
    { label: "វិច្ឆិកា", value: "11" },
    { label: "ធ្នូ", value: "12" },
  ],
  ko: [
    { label: "1월", value: "01" },
    { label: "2월", value: "02" },
    { label: "3월", value: "03" },
    { label: "4월", value: "04" },
    { label: "5월", value: "05" },
    { label: "6월", value: "06" },
    { label: "7월", value: "07" },
    { label: "8월", value: "08" },
    { label: "9월", value: "09" },
    { label: "10월", value: "10" },
    { label: "11월", value: "11" },
    { label: "12월", value: "12" },
  ],
  lb: [
    { label: "Januar", value: "01" },
    { label: "Februar", value: "02" },
    { label: "Mäerz", value: "03" },
    { label: "Abrëll", value: "04" },
    { label: "Mee", value: "05" },
    { label: "Juni", value: "06" },
    { label: "Juli", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "November", value: "11" },
    { label: "Dezember", value: "12" },
  ],
  lt: [
    { label: "Sausis", value: "01" },
    { label: "Vasaris", value: "02" },
    { label: "Kovas", value: "03" },
    { label: "Balandis", value: "04" },
    { label: "Gegužė", value: "05" },
    { label: "Birželis", value: "06" },
    { label: "Liepa", value: "07" },
    { label: "Rugpjūtis", value: "08" },
    { label: "Rugsėjis", value: "09" },
    { label: "Spalis", value: "10" },
    { label: "Lapkritis", value: "11" },
    { label: "Gruodis", value: "12" },
  ],
  lv: [
    { label: "Janvāris", value: "01" },
    { label: "Februāris", value: "02" },
    { label: "Marts", value: "03" },
    { label: "Aprīlis", value: "04" },
    { label: "Maijs", value: "05" },
    { label: "Jūnijs", value: "06" },
    { label: "Jūlijs", value: "07" },
    { label: "Augusts", value: "08" },
    { label: "Septembris", value: "09" },
    { label: "Oktobris", value: "10" },
    { label: "Novembris", value: "11" },
    { label: "Decembris", value: "12" },
  ],
  mk: [
    { label: "Јануари", value: "01" },
    { label: "Февруари", value: "02" },
    { label: "Март", value: "03" },
    { label: "Април", value: "04" },
    { label: "Мај", value: "05" },
    { label: "Јуни", value: "06" },
    { label: "Јули", value: "07" },
    { label: "Август", value: "08" },
    { label: "Септември", value: "09" },
    { label: "Октомври", value: "10" },
    { label: "Ноември", value: "11" },
    { label: "Декември", value: "12" },
  ],
  gl: [
    { label: "Xaneiro", value: "01" },
    { label: "Febreiro", value: "02" },
    { label: "Marzo", value: "03" },
    { label: "Abril", value: "04" },
    { label: "Maio", value: "05" },
    { label: "Xuño", value: "06" },
    { label: "Xullo", value: "07" },
    { label: "Agosto", value: "08" },
    { label: "Setembro", value: "09" },
    { label: "Outubro", value: "10" },
    { label: "Novembro", value: "11" },
    { label: "Decembro", value: "12" },
  ],
  he: [
    { label: "ינואר", value: "01" },
    { label: "פברואר", value: "02" },
    { label: "מרץ", value: "03" },
    { label: "אפריל", value: "04" },
    { label: "מאי", value: "05" },
    { label: "יוני", value: "06" },
    { label: "יולי", value: "07" },
    { label: "אוגוסט", value: "08" },
    { label: "ספטמבר", value: "09" },
    { label: "אוקטובר", value: "10" },
    { label: "נובמבר", value: "11" },
    { label: "דצמבר", value: "12" },
  ],
  hi: [
    { label: "जनवरी", value: "01" },
    { label: "फरवरी", value: "02" },
    { label: "मार्च", value: "03" },
    { label: "अप्रेल", value: "04" },
    { label: "मई", value: "05" },
    { label: "जून", value: "06" },
    { label: "जूलाई", value: "07" },
    { label: "अगस्त", value: "08" },
    { label: "सितम्बर", value: "09" },
    { label: "अक्टूबर", value: "10" },
    { label: "नवम्बर", value: "11" },
    { label: "दिसम्बर", value: "12" },
  ],
  hr: [
    { label: "Siječanj", value: "01" },
    { label: "Veljača", value: "02" },
    { label: "Ožujak", value: "03" },
    { label: "Travanj", value: "04" },
    { label: "Svibanj", value: "05" },
    { label: "Lipanj", value: "06" },
    { label: "Srpanj", value: "07" },
    { label: "Kolovoz", value: "08" },
    { label: "Rujan", value: "09" },
    { label: "Listopad", value: "10" },
    { label: "Studeni", value: "11" },
    { label: "Prosinac", value: "12" },
  ],
  "hu-HU": [
    { label: "Január", value: "01" },
    { label: "Február", value: "02" },
    { label: "Március", value: "03" },
    { label: "Április", value: "04" },
    { label: "Május", value: "05" },
    { label: "Június", value: "06" },
    { label: "Július", value: "07" },
    { label: "Augusztus", value: "08" },
    { label: "Szeptember", value: "09" },
    { label: "Október", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],
  hy: [
    { label: "Հունվար", value: "01" },
    { label: "Փետրվար", value: "02" },
    { label: "Մարտ", value: "03" },
    { label: "Ապրիլ", value: "04" },
    { label: "Մայիս", value: "05" },
    { label: "Հունիս", value: "06" },
    { label: "Հուլիս", value: "07" },
    { label: "Օգոստոս", value: "08" },
    { label: "Սեպտեմբեր", value: "09" },
    { label: "Հոկտեմբեր", value: "10" },
    { label: "Նոյեմբեր", value: "11" },
    { label: "Դեկտեմբեր", value: "12" },
  ],
    "my-MM": [
        { label: "ဇန်နဝါရီ", value: "01" },
        { label: "ဖေဖော်ဝါရီ", value: "02" },
        { label: "မတ်", value: "03" },
        { label: "ဧပြီ", value: "04" },
        { label: "မေ", value: "05" },
        { label: "ဇွန်", value: "06" },
        { label: "ဇူလိုင်", value: "07" },
        { label: "သြဂုတ်", value: "08" },
        { label: "စက်တင်ဘာ", value: "09" },
        { label: "အောက်တိုဘာ", value: "10" },
        { label: "နိုဝင်ဘာ", value: "11" },
        { label: "ဒီဇင်ဘာ", value: "12" },
  ],
  "cs-CZ": [
        { label: "leden", value: "01" },
        { label: "únor", value: "02" },
        { label: "březen", value: "03" },
        { label: "duben", value: "04" },
        { label: "květen", value: "05" },
        { label: "červen", value: "06" },
        { label: "červenec", value: "07" },
        { label: "srpen", value: "08" },
        { label: "září", value: "09" },
        { label: "říjen", value: "10" },
        { label: "listopad", value: "11" },
        { label: "prosinec", value: "12" },
  ]
};
